import { call, put, takeEvery } from "redux-saga/effects";
import { types } from "../action-types";
import { getNotesApi, postNotesApi, getProfileReviewsAPi, updateNotesApi, deleteNotesApi, getConversationIDApi, removePrivateTalentAPI, getAssociatedTalentsAPI } from "../../API/API";
import { getAuthToken } from "../store";
import { fetchUserProfile } from "../actions";

function* getProfileDetailsSaga(action) {
    try {
        const { id } = action.payload;
        const response = yield call(() => getAssociatedTalentsAPI({ SkillListingId: parseInt(id) }));
        yield put({ type: types.FETCH_PROFILE_DETAILS_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: types.FETCH_PROFILE_DETAILS_FAILURE, error });
    }
}

function* getProfileReviewsSaga(action) {
    try {
        const { id } = action.payload;
        const response = yield call(() => getProfileReviewsAPi(action.payload));
        yield put({ type: types.FETCH_PROFILE_REVIEWS_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: types.FETCH_PROFILE_REVIEWS_FAILURE, error });
    }
}

function* postNotesSaga(action) {
    try {
        const response = yield call(() => postNotesApi(action.payload));
        yield put({ type: types.POST_NOTES_SUCCESS, payload: response.data });
        yield put({ type: types.GET_NOTES_REQUESTED, payload: { id: action.payload.SkillListingId } });
    } catch (error) {
        yield put({ type: types.POST_NOTES_FAILURE, error });
    }
}

function* getNotesSaga(action) {
    try {
        const response = yield call(() => getNotesApi(action.payload));
        yield put({ type: types.GET_NOTES_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: types.GET_NOTES_FAILURE, error });
    }
}

function* updateNotesSaga(action) {
    try {
        const { SkillListingId, ...notePayload } = action.payload;
        const response = yield call(() => updateNotesApi(notePayload));
        yield put({ type: types.UPDATES_NOTES_SUCCESS, payload: response.data });
        yield put({ type: types.GET_NOTES_REQUESTED, payload: { id: SkillListingId } });
    } catch (error) {
        yield put({ type: types.UPDATES_NOTES_FAILURE, error });
    }
}

function* deleteNotesSaga(action) {
    try {
        const response = yield call(() => deleteNotesApi(action.payload));
        yield put({ type: types.DELETE_NOTE_SUCCESS, payload: action.payload.noteId });
    } catch (error) {
        yield put({ type: types.DELETE_NOTE_FAILURE, error });
    }
}

function* getConversationIdSaga(action) {
    try {
        const response = yield call(() => getConversationIDApi(action.payload));
        yield put({ type: types.GET_CONVERSATION_ID_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: types.GET_CONVERSATION_ID_FAILURE, error });
    }
}

function* removePrivateTalentSaga(action) {
    try {
        const response = yield call(() => removePrivateTalentAPI(action.payload));
        yield put({ type: types.REMOVE_PRIVATE_MARKET_TALENT_SUCCESS, payload: response.data });
        yield put(fetchUserProfile(getAuthToken()));
    } catch (error) {
        yield put({ type: types.REMOVE_PRIVATE_MARKET_TALENT_FAILURE, error });
    }
}

export function* watchGetProfileDetails() {
    yield takeEvery(types.FETCH_PROFILE_DETAILS_REQUESTED, getProfileDetailsSaga);
}

export function* watchGetProfileReviews() {
    yield takeEvery(types.FETCH_PROFILE_REVIEWS_REQUESTED, getProfileReviewsSaga);
}

export function* watchPostNotesSaga() {
    yield takeEvery(types.POST_NOTES_REQUESTED, postNotesSaga);
}

export function* watchgetNotesSaga() {
    yield takeEvery(types.GET_NOTES_REQUESTED, getNotesSaga);
}

export function* watchUpdateNotesSaga() {
    yield takeEvery(types.UPDATES_NOTES_REQUESTED, updateNotesSaga);
}

export function* watchDeleteNotesSaga() {
    yield takeEvery(types.DELETE_NOTE_REQUESTED, deleteNotesSaga);
}

export function* watchGetConversationIdSaga() {
    yield takeEvery(types.GET_CONVERSATION_ID_INIT, getConversationIdSaga);
}

export function* watchRemovePrivateTalentSaga() {
    yield takeEvery(types.REMOVE_PRIVATE_MARKET_TALENT, removePrivateTalentSaga);
}